import axios from 'axios'
import config from '../../constants/endpoints'
import { getHeaders, getError } from '../helpers'

const {
  endpoints: {
    marketing: { campaigns: url, exportCsv, launchCampaign: launchCampaignUrl, notifySale: urlNotifySale },
  },
} = config

const getUrl = (id = null) => url.replace(':id', id ? id : '')

/** Post a campaign */
export const postCampaign = (data) =>
  axios({
    url: getUrl(),
    method: 'post',
    data,
    headers: getHeaders(true),
  })

/**
 * Get campaign details
 */
export const getCampaign = (id) =>
  axios({
    url: getUrl(id),
    method: 'get',
    headers: getHeaders(true),
  })

/**
 * Get campaigns
 */
export const getCampaigns = (params) =>
  axios({
    url: getUrl(),
    method: 'get',
    headers: getHeaders(true),
    params,
  })

/**
 * Put campaign
 */
export const updateCampaign = ({ id, data }) =>
  axios({
    url: getUrl(id),
    method: 'put',
    headers: getHeaders(true),
    data: { ...data },
  })

/**
 * Delete campaign
 */
export const deleteCampaign = (id) =>
  axios({
    url: getUrl(id),
    method: 'delete',
    headers: getHeaders(true),
  })
    .catch(data => {
      throw getError(data)
    })

/**
 * Launch campaign
 * @param {String} id
 * @param {String} launchDate
 */
export const launchCampaign = ({ id, launchDate }) =>
  axios({
    url: launchCampaignUrl.replace(':id', id),
    method: 'post',
    headers: getHeaders(true),
    data: { launchDate },
  })

/**
 * Get campaigns
 */
export const getCSVInfo = (params) =>
  axios({
    url: exportCsv,
    method: 'get',
    responseType: 'blob',
    headers: getHeaders(true),
    params,
  })

/**
 * Post noify sale
 * id: campaignd id
 * body { userId, reference, text, price: {value,currency}}
 */
export const notifySale = (id, body) =>
  axios({
    url: urlNotifySale.replace(':id', id),
    method: 'post',
    headers: getHeaders(true),
    data: body,
  })
